// extracted by mini-css-extract-plugin
module.exports = {"no-scrollbar":"MobileViewFullScreenModal_no-scrollbar__8OzB8"};